function isDesktop(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  return window.matchMedia('(min-width: 1024px)').matches;
}

export default isDesktop;
